import React, { useState, useEffect } from "react";
import { Spinner } from "../../StyledComponent";
import { getEtapas } from "../../../services/meAjuda";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";

import { ReactComponent as LerMais } from "../../../assets/novosicones/MeAjuda/LerMais.svg";
import { ReactComponent as LerMenos } from "../../../assets/novosicones/MeAjuda/LerMenos.svg";

const MinhaCasaICon = ({ tema }) => {
  const [loading, setLoading] = useState(true);
  const [minhaCasaMinhaVida, setminhaCasaMinhaVida] = useState([]);

  const [answerExpanded, setAnswerExpanded] = useState(false);

  const [perguntaSelecionada, setPerguntaSelecionada] = useState("");

  const handleChange = (panel) => (event, isExpanded) => {
    setAnswerExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    get();
  }, []);

  async function get() {
    let resultGetMinhaCasaMinhaVida = await getEtapas();
    setminhaCasaMinhaVida(trataArray(resultGetMinhaCasaMinhaVida));
    setLoading(false);
  }

  function trataArray(resultGetminhaCasaMinhaVida) {
    let tempArray = [];
    resultGetminhaCasaMinhaVida.forEach((item) => {
      tempArray.push({
        Pergunta: item.Processo,
        Resposta: item.Descricao,
        id: item.id,
      });
    });
    return tempArray;
  }

  if (loading) return <Spinner />;

  return (
    <>
      {minhaCasaMinhaVida.map((pergunta, index) => {
        return (
          <Accordion
            expanded={answerExpanded == index + 1}
            onChange={handleChange(index + 1)}
            onClick={() => {
              if (perguntaSelecionada == index + 1) setPerguntaSelecionada("");
              else setPerguntaSelecionada(index + 1);
            }}
            key={index + 1}
            accessKey={index + 1}
            id={`perguntaId${index + 1}`}
          >
            <AccordionSummary
              expandIcon={
                perguntaSelecionada == index + 1 ? (
                  <LerMenos style={{ fill: "#ffffff" }} />
                ) : (
                  <LerMais style={{ fill: "#ffffff" }} />
                )
              }
              aria-controls="panel1bh-content"
              style={
                perguntaSelecionada == index + 1
                  ? { backgroundColor: tema, color: "#ffffff" }
                  : { backgroundColor: "#d1d1d1", color: "#ffffff" }
              }
            >
              <Typography
                sx={{
                  width: "33%",
                  flexShrink: 0,
                  backgroundColor: "#654987",
                }}
              >
                {minhaCasaMinhaVida && index + 1 + " - " + pergunta.Pergunta}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="centralized-column">
                <Typography
                  style={{ color: "#4D4D4D" }}
                  id={`respostaId${pergunta.subject}`}
                >
                  {pergunta.questions == undefined && pergunta.Resposta}
                </Typography>
              </div>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default MinhaCasaICon;
